import { ProductInfo, PredefinedConfiguration } from 'sofa-reborn-react';

import ThunksUtil from '../utils/ThunksUtil';

import { IProduct } from '@inter-ikea-kompis/types';

export default class PredefinedProductInfoParser {
	public parse(
		predefinedConfigurations: PredefinedConfiguration[],
		useLocalIds: boolean,
		fetchedProducts: IProduct[]
	): ProductInfo {
		const productInfo = new Object() as ProductInfo;
		const predefinedIds = predefinedConfigurations.map((predefinedItem) => {
			return predefinedItem.isArticle ? `ART-${predefinedItem.id}` : `SPR-${predefinedItem.id}`;
		});
		fetchedProducts.forEach((product) => {
			if (predefinedIds.includes(product.itemId)) {
				productInfo[ThunksUtil.getProductItemId(product, useLocalIds)] = product;
			}
		});
		return productInfo;
	}
}
